export default __webpack_public_path__ + "static/image-2021-12-21-10-15-17-811-5d9aae4de4a6d1300f4fbea89b15edb9.png";